<template>
  <div class="HomeHeader noprint">
    <div id="nav">
      <div class="price">
        <div class="tooltip">
          <a href="https://tw9999.tw" target="_blank">即時金價：{{ ounceGoldPrice }} 盎司 {{ taiwaneseGoldPrice }} 台錢</a>
          <span class="tooltiptext">查看台灣銀樓報價系統</span>
        </div>
        <!-- RWD hamburger -->
        <div class="hamburger" @click="hamburgerMenu = !hamburgerMenu">
          <svg width="34" height="34" viewBox="0 0 34 34">
            <g fill="none" fill-rule="evenodd">
              <g fill="#A8894C">
                <path d="M8 10h17.838v1.765H8zM8 16h17.838v1.765H8zM8 22h17.838v1.765H8z"></path>
              </g>
              <circle cx="17" cy="17" r="16.25" fill-rule="nonzero" stroke="#A8894C" stroke-width="1.5"></circle>
            </g>
          </svg>
        </div>
      </div>
      <div class="news">
        <router-link to="/gold/latest_newsList">最新消息</router-link>
      </div>
      <div class="sameCompany">
        <a @click="modalIsOpen = true" v-if="!isLoginOrIsSpecialMember">特約服務</a>
      </div>
      <div class="logo">
        <router-link to="/gold/homepage">
          <img src="@/images/logo@2x.png">
        </router-link>
        <span v-if="isSpecialMember">
          <img src="@/icons/svg/tag-specialMember.svg" alt="special-member-tag">
        </span>
      </div>
      <div class="navigation">
        <div class="nav-item all-products">
          <a @click.prevent="toggleDropdown">所有商品</a>
          <div class="dropdown-menu" v-show="showDropdown">
            <ul>
              <li @click="goCustomizeGold">客製金牌</li>
              <li @click="goCustomizeGift">週歲 / 生日 / 送禮金牌</li>
              <li @click="goCustomizeFan">黃金法扇</li>
              <li @click="goToTrandition">傳統金牌</li>
            </ul>
          </div>
        </div>
        <div class="nav-item">
          <router-link to="/gold/service/service_takeback">黃金收購</router-link>
        </div>
        <div class="nav-item">
          <router-link to="/gold/homepage#anchor_adjustment">純金品客製</router-link>
        </div>
        <div class="icon">
          <div class="service_icon icon_item tooltip" v-on:click="helpRouter">
            <svg width="34" height="34" viewBox="0 0 34 34">
              <g fill="none" fill-rule="evenodd">
                <circle cx="17" cy="17" r="16.25" stroke="#A8894C" stroke-width="1.5"></circle>
                <g fill="#A8894C">
                  <path
                    d="M19.15 11.592c.418.504.625 1.098.625 1.782 0 .49-.143.96-.427 1.415a3.47 3.47 0 0 1-.62.744l-.854.829c-.82.79-1.35 1.49-1.592 2.102-.243.611-.364 1.417-.364 2.416h1.903c0-.88.102-1.546.305-1.997.203-.45.647-1 1.331-1.651.941-.895 1.566-1.573 1.875-2.034.31-.46.466-1.062.466-1.803 0-1.222-.422-2.227-1.267-3.014-.845-.787-1.969-1.179-3.372-1.179-1.518 0-2.712.46-3.582 1.378-.87.919-1.304 2.132-1.304 3.642h1.903c.035-.909.182-1.604.437-2.086.456-.866 1.279-1.3 2.47-1.3.961 0 1.652.252 2.068.756zM15.874 22.618h2.128v2.18h-2.128z">
                  </path>
                </g>
              </g>
            </svg>
            <span class="tooltiptext">幫助與說明</span>
          </div>

          <div class="member_icon icon_item tooltip" v-on:click="memberRouter">
            <div v-if="isSpecialMember">
              <svg width="34" height="34" viewBox="0 0 34 34">
                <g fill="none" fill-rule="evenodd">
                  <circle cx="17" cy="17" r="16.25" stroke="#A8894C" stroke-width="1.5" />
                  <text fill="#A8894C" font-family="STSongti-TC-Bold, Songti TC" font-size="19" font-weight="bold"
                    letter-spacing=".152">
                    <tspan x="8" y="22">特</tspan>
                  </text>
                </g>
              </svg>
              <span class="tooltiptext">特約會員</span>
            </div>
            <div v-else>
              <svg width="34" height="34" viewBox="0 0 34 34">
                <g fill="none" fill-rule="nonzero">
                  <circle cx="17" cy="17" r="16.25" stroke="#A8894C" stroke-width="1.5"></circle>
                  <path fill="#A8894C"
                    d="M23.364 19.636a8.965 8.965 0 0 0-3.42-2.145 5.201 5.201 0 0 0 2.26-4.288A5.209 5.209 0 0 0 17 8a5.209 5.209 0 0 0-5.203 5.203c0 1.777.896 3.349 2.26 4.288a8.965 8.965 0 0 0-3.42 2.145A8.941 8.941 0 0 0 8 26h1.406c0-4.187 3.407-7.594 7.594-7.594s7.594 3.407 7.594 7.594H26a8.941 8.941 0 0 0-2.636-6.364zM17 17a3.801 3.801 0 0 1-3.797-3.797A3.801 3.801 0 0 1 17 9.406a3.801 3.801 0 0 1 3.797 3.797A3.801 3.801 0 0 1 17 17z">
                  </path>
                </g>
              </svg>
              <span class="tooltiptext">個人會員</span>
            </div>
          </div>
          <router-link to="/gold/cart" class="cart-icon icon_item tooltip">
            <svg width="34" height="34" viewBox="0 0 34 34">
              <g fill="none" fill-rule="nonzero" stroke="#A8894C">
                <circle cx="17" cy="17" r="16.25" stroke-width="1.5" />
                <path fill="#A8894C" stroke-width=".2"
                  d="M12.63 20.137H23.566c.27 0 .506-.18.58-.44l2.412-8.496a.61.61 0 0 0-.099-.532.602.602 0 0 0-.48-.242H11.24l-.43-1.952A.604.604 0 0 0 10.22 8H6.604A.605.605 0 0 0 6 8.607c0 .335.27.607.603.607h3.134l2.177 9.86a1.823 1.823 0 0 0 .718 3.49h10.933a.605.605 0 0 0 .603-.607.605.605 0 0 0-.603-.606H12.632a.606.606 0 0 1-.603-.607c0-.334.27-.606.602-.607zm12.548-8.496l-2.068 7.282h-9.994l-1.608-7.282h13.67z" />
                <path stroke-width="1.3"
                  d="M12 25.5c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5-.673-1.5-1.5-1.5-1.5.673-1.5 1.5zM21 25.5c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5-.673-1.5-1.5-1.5-1.5.673-1.5 1.5z" />
              </g>
            </svg>
            <span class="tooltiptext">購物車</span>
            <span class="shopping-cart-count">{{ cartOrderNum }}</span>
          </router-link>
        </div>
      </div>
    </div>
    <div id="mobile-nav">
      <ul v-bind:class="{ 'displaynone': hamburgerMenu }">
        <li @click="hamburgerMember">
          <div>
            <div>個人會員</div>
          </div>
        </li>
        <li @click="goCustomizeGold">客製金牌</li>
        <li @click="goCustomizeGift">週歲 / 生日 / 送禮金牌</li>
        <li @click="goCustomizeFan">黃金法扇</li>
        <li @click="goToTrandition">傳統金牌</li>
        <li @click="closeHamburgerMenu">
          <div>
            <router-link to="/gold/service_mobile/service_takeback">黃金收購</router-link>
          </div>
        </li>
        <li @click="closeHamburgerMenu">
          <div>
            <router-link to="/gold/latest_newsList">最新消息</router-link>
          </div>
        </li>
        <li v-if="!isLoginOrIsSpecialMember" @click="openModal">
          <div>
            <a>特約服務</a>
          </div>
        </li>
        <li @click="closeHamburgerMenu">
          <div>
            <router-link to="/gold/homepage#contact_us">純金品客製</router-link>
          </div>
        </li>
        <li @click="hamburgerHelp">
          <div>
            <router-link to="/gold/service">幫助與說明</router-link>
          </div>
        </li>
        <li>
          <div class="price-mobile" @click="closeHamburgerMenu">
            <a href="https://tw9999.tw" target="_blank">即時金價：{{ ounceGoldPrice }} 盎司 {{ taiwaneseGoldPrice }} 台錢</a>
          </div>
          <p @click="closeHamburgerMenu">
            <a href="https://tw9999.tw" target="_blank">點擊查看詳細報價</a>
          </p>
        </li>
      </ul>
    </div>
    <template>
      <div class="lightbox" v-show="modalIsOpen" v-body-scroll-lock="modalIsOpen">
        <div class="lightbox-target">
          <div class="title">
            <img src="@/images/contracted_store_title@2x.png" alt="">
          </div>
          <div class="content-container">
            <p>此功能目前只開放給登記為特約廠商，若有意成為金牌王國的特約廠商，請先登入後至會員中心申請。</p>
            <p>若已經是會員，請點選以下按鈕申請。</p>
          </div>
          <div class="contracted-store-btn-container">
            <button @click="toContractedStore">成為特約廠商</button>
          </div>
          <div class="lightbox-close gold-background-close" @click="closeModal">
            <img src="@/images/icon-close@2x-white.png" alt="close">
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";

export default {
  name: "HomeHeader",
  data() {
    return {
      deviceSize: 0,
      hamburgerMenu: true,
      ounceGoldPrice: "",
      taiwaneseGoldPrice: "",
      viewHeight: 0,
      modalIsOpen: false,
      showDropdown: false
    };
  },
  created() {
    this.setDeviceSize();
    let haveCookieToken = Cookies.getJSON("goldUser");
    if (haveCookieToken) {
      this.$store.dispatch("setToken", haveCookieToken);
      this.$store.dispatch("tokenGetMemberInfo");
    }
    this.getGoldPrice();
    setInterval(
      function() {
        this.getGoldPrice();
      }.bind(this),
      60000
    );
    this.getCartOrderNum();
  },
  mounted() {
    this.handleCloseDropdown();
  },
  destroyed() {
    this.removeAllEventListener();
  },
  watch: {
    hamburgerMenu() {
      if (this.hamburgerMenu) {
        document.querySelector("body").className = "";
      } else {
        document.querySelector("body").className = "bodyhidden";
      }
    }
  },
  methods: {
    async getGoldPrice() {
      try {
        let res = await this.$store.dispatch("getGoldPrice");
        this.ounceGoldPrice = res.gold.ask;
        this.taiwaneseGoldPrice = res.gold.ask_NT;
      } catch (e) {
        alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
      }
    },
    closeHamburgerMenu() {
      this.hamburgerMenu = true;
    },
    hamburgerMember() {
      this.closeHamburgerMenu();
      this.memberRouter();
    },
    hamburgerHelp() {
      this.closeHamburgerMenu();
      this.helpRouter();
    },
    memberRouter() {
      let haveLocalToken = this.$store.getters.getToken;
      let size = parseInt(this.$store.getters.getDeviceSize);
      if (haveLocalToken) {
        if (size > 585) {
          this.$router.push("/gold/member");
        } else {
          this.$router.push("/gold/member_mobile");
        }
      } else {
        this.$router.push("/gold/member_login");
      }
    },
    helpRouter() {
      let size = parseInt(this.$store.getters.getDeviceSize);
      if (size > 585) {
        this.$router.push("/gold/service");
      } else {
        this.$router.push("/gold/service_mobile");
      }
    },
    setDeviceSize() {
      let size = document.body.clientWidth;
      this.$store.dispatch("setDeviceSize", size);
    },
    getCartOrderNum() {
      let localStorageCartorder = JSON.parse(localStorage.getItem("cartorder"));
      if (localStorageCartorder === null) {
        this.$store.dispatch("updateCartOrderNum", 0);
      } else {
        let updateCartOrderNum = 0;
        localStorageCartorder.forEach(item => {
          updateCartOrderNum = updateCartOrderNum + item.amount;
        });
        this.$store.dispatch("updateCartOrderNum", updateCartOrderNum);
      }
    },
    toContractedStore() {
      this.modalIsOpen = false;
      if (this.$store.getters.getToken === "") {
        this.$router.push("/gold/member_login");
      } else {
        if (this.$store.getters.getDeviceSize < 585) {
          this.$router.push("/gold/member_mobile/contracted_store_form");
        } else {
          this.$router.push("/gold/member/contracted_store_form");
        }
      }
    },
    closeModal() {
      this.modalIsOpen = false;
    },
    openModal() {
      this.closeHamburgerMenu();
      this.modalIsOpen = true;
    },
    goToTrandition() {
      this.closeHamburgerMenu();
      const metal = this.$store.getters.customizeMetalByComponentCode("AD");
      this.$store.dispatch("updateCostom", {
        key: "shape",
        content: metal.shape
      });
      this.$store.dispatch("updateCostom", {
        key: "style",
        content: metal.name
      });
      this.$store.dispatch("updateCostom", {
        key: "accessory",
        content: metal.accessory[0]
      });
      this.$store.dispatch("updateCostom", {
        key: "text",
        content: { ...this.$store.getters.currentCustom.text, respect: "" }
      });
      this.$store.dispatch("updateComponentCode", metal.code);
      this.$router.push({ name: "customize_step3" });
      this.closeDropdown();
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    closeDropdown() {
      this.showDropdown = false;
    },
    goCustomizeGold() {
      this.closeHamburgerMenu();
      this.$router.push({ name: "customize" });
      this.closeDropdown();
    },
    goCustomizeGift() {
      this.closeHamburgerMenu();
      this.$router.push({ name: "customize_gift" });
      this.closeDropdown();
    },
    goCustomizeFan() {
      this.closeHamburgerMenu();
      this.$router.push({ name: "customize_fan" });
      this.closeDropdown();
    },
    closeDropdownWhenClickOutside(e) {
      const allProducts = document.querySelector(".all-products");
      const isClickInside = allProducts.contains(e.target);
      if (!isClickInside) this.closeDropdown();
    },
    handleCloseDropdown() {
      const body = document.querySelector("body");
      body.addEventListener("click", this.closeDropdownWhenClickOutside);
    },
    removeAllEventListener() {
      const body = document.querySelector("body");
      body.addEventListener("click", this.closeDropdownWhenClickOutside);
    }
  },
  computed: {
    cartOrderNum() {
      return this.$store.getters.getCartOrderNum;
    },
    isLoginOrIsSpecialMember() {
      if (this.$store.getters.getToken === "") {
        return false;
      } else if (this.$store.getters.getSpecialMemberState === null) {
        return false;
      } else {
        return true;
      }
    },
    isSpecialMember() {
      if (
        this.$store.getters.getToken !== "" &&
        this.$store.getters.getSpecialMemberState === 1
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
#nav {
  position: fixed;
  width: 100%;
  background: url(../../images/header-paper@2x.png);
  display: grid;
  grid-template-columns: auto auto auto 1fr auto;
  grid-template-rows: 80px;
  box-shadow: 0 4px 4px 0 rgba(168, 137, 76, 0.4);
  align-items: center;
  z-index: 9999;

  @media screen and (max-width: 1155px) {
    grid-template-columns: 1fr auto 1fr;
  }

  a {
    cursor: pointer;
  }
}

.price {
  text-align: left;

  .tooltip {
    display: inline-block;
  }

  .tooltip .tooltiptext {
    left: 100px;
    width: 200px;
    top: 100%;
  }

  a {
    border: 1px $primaryDeepColor solid;
    padding: 10px;
    margin: 20px 27px;
    display: inline-block;

    &:hover {
      transition: all 0.5s ease-in-out;
      background-color: $primaryDeepColor;
      color: $secondaryColor3;
    }

    @media screen and (max-width: 1155px) {
      display: none;
    }
  }
}

.news {
  padding-right: 24px;
}

.sameCompany {
  padding: 0 24px;
}

.news,
.sameCompany {
  font-weight: bold;

  a:hover {
    border-bottom: 2px $primaryLightColor solid;
  }

  @media screen and (max-width: 1155px) {
    display: none;
  }
}

.hamburger {
  display: none;
  margin-left: 16px;

  @media screen and (max-width: 1155px) {
    display: inline-block;
    margin-left: 30px;

    &:hover {
      cursor: pointer;
    }
  }
}

.tooltip {
  position: relative;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 119px;
  background-color: white;
  color: $secondaryDeepColor1;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 110%;
  left: 50%;
  margin-left: -60px;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent white transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;

  @media screen and (max-width: 1155px) {
    visibility: hidden;
  }
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0 5px 0;
  margin: auto;

  a {
    width: 163px;
    margin-right: 10px;

    @media screen and (max-width: 940px) {
      width: 117px;
    }

    @include phone {
      width: 100px;
    }
  }

  span {
    width: 56px;

    @include phone {
      width: 45px;
    }
  }

  img {
    width: 100%;
  }
}

.navigation {
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .nav-item {
    display: inline-block;
    padding: 0px 24px;

    @media screen and (max-width: 1225px) {
      padding: 0px 12px;
    }

    @media screen and (max-width: 380px) {
      display: none;
    }

    > a {
      &:hover {
        border-bottom: 2px $primaryLightColor solid;
      }

      @media screen and (max-width: 1155px) {
        display: none;
      }
    }
  }

  .nav-item {
    position: relative;
    .dropdown-menu {
      position: absolute;
      top: 30px;
      left: 5px;
      width: 190px;
    }
  }
  .nav-item {
    .dropdown-menu {
      text-align: left;
      background: #fff;
      filter: drop-shadow(8px 8px 7px rgba(0, 0, 0, 0.3));
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        li {
          padding: 12px;
          color: #4a4a4a;
          cursor: pointer;
        }
        li:hover {
          background-color: #f6f6f6;
        }
      }
    }
  }

  .icon {
    display: flex;

    .icon_item {
      margin-right: 24px;
      cursor: pointer;
    }

    .service_icon {
      @media screen and (max-width: 1155px) {
        display: none;
      }
    }

    .member_icon {
      @media screen and (max-width: 1155px) {
        display: none;
      }
    }

    .cart-icon {
      position: relative;

      @media screen and (max-width: 1155px) {
        margin-right: 30px;
      }
    }

    .shopping-cart-count {
      position: absolute;
      top: -10px;
      right: -10px;
      font-size: 12px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      color: #fff;
      border-radius: 50px;
      background: $primaryDeepColor;
    }

    .hover {
      display: none;

      &:hover {
        display: inline-block;
        background-color: $secondaryColor3;
        color: $secondaryDeepColor1;
      }
    }
  }
}

.HomeHeader {
  a {
    color: $primaryDeepColor;
    text-decoration: none;
  }
}

#mobile-nav {
  position: fixed;
  width: 100%;
  z-index: 9999;
  display: none;

  @media screen and (max-width: 1155px) {
    display: block;
    margin-top: 80px;
  }

  ul {
    margin: 0;
    padding: 0;
    background: #fff;
    height: 100vh; //在 App.vue 加入 position: fixed; 讓 ios toolbar 的 高不會擋到
    overflow: scroll;
  }

  li {
    list-style: none;
    padding-top: 3%;
    padding-bottom: 3%;
    font-size: 17px;
    color: $primaryDeepColor;
    font-weight: 800;

    &:hover {
      cursor: pointer;
    }

    > div {
      display: inline-block;
    }
  }

  .price-mobile {
    border: 1px solid $primaryDeepColor;
    padding: 7px 17px;
    display: inline-block;
  }
}

.displaynone {
  display: none;
}

.lightbox {
  position: fixed;
  width: 100%;
  height: 100%; //用 100vh 在真 ios 手機上不是置中
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1111111;

  .lightbox-target {
    max-width: 600px;
    padding: 30px 20px 60px;
    background: $secondaryColor3;

    .title {
      width: 28%;
      margin: auto;

      img {
        width: 100%;
      }
    }
  }

  .content-container {
    padding: 0 15%;
    color: $primaryDeepColor;
  }

  .contracted-store-btn-container {
    margin-top: 50px;

    button {
      @extend %button;
    }
  }

  .lightbox-close {
    max-width: 45px;
    max-height: 45px;
    padding: 8px;
    background: $primaryDeepColor;
    color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .lightbox-close.gold-background-close {
    display: flex;
    justify-content: center;
    align-items: center;
    background: $primaryDeepColor;
    box-sizing: border-box;
    padding: 8px;

    img {
      width: 20px;
    }
  }
}
</style>
